import fromAnyToDecimal from 'utils/converters/any/fromAnyToDecimal.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromAnyToString from 'utils/converters/fromAnyToString';

export const fromFeeToDto = (fee) => ({
  name: fromAnyToString(fee.name),
  amount: fee.amount ? fromAnyToDecimal(fee.amount) : null,
  percentage: fee.percentage ? fromAnyToDecimal(fee.percentage) : null,
  applied_to: fromAnyToString(fee.appliedTo),
  is_default: fromAnyToBool(fee.isDefault),
});
